export const TOKEN_NAME = 'craspice-token';

export const HOME_CRUMB = 'Home';
export const CITATION_BULK_UPLOAD = 'Citation Bulk Upload';
export const JOB_STATUS_DETAIL_VIEW = 'Detailed View';

export const REFRESH_BUTTON_TITLE = 'Refresh to view updated records.';

export const JOB_STATUS_MAPPING = {
  completed: 'Completed',
  failed: 'Failed',
  inprogress: 'Inprogress',
  created: 'Created',
  publish_failed: 'Publish Failed',
  publish_inprogress: 'Publish Inprogress',
  published: 'Published'
};

export const JOB_STATUS_LABEL_MAPPING = {
  completed: 'completed-label',
  failed: 'failed-label icon-24-warning-bold',
  inprogress: 'progress-label',
  created: 'created-label',
  publish_failed: 'failed-label icon-24-warning-bold',
  publish_inprogress: 'published-status-label',
  published: 'published-label'
};

export const ASSET_TYPE = [
  { value: 'audios', label: 'Audios' },
  { value: 'bulkImport', label: 'BulkImport' },
  { value: 'certificates', label: 'Certificates' },
  { value: 'changeNotification', label: 'Change Notification' },
  {
    value: 'ChangeNotificationBulkImport',
    label: 'Change Notification Bulk Import'
  },
  { value: 'citation', label: 'Citation' },
  { value: 'corporateCommunications', label: 'Corporate Communications' },
  {
    value: 'corporateMarketingDocuments',
    label: 'Corporate Marketing Documents'
  },
  { value: 'guidedNavigationAttribute', label: 'Guided Navigation Attribute' },
  { value: 'guidedNavigationCategory', label: 'Guided Navigation Category' },
  {
    value: 'GuidedNavigationInfographic',
    label: 'Guided Navigation Infographic'
  },
  { value: 'iDDMarketingImages', label: 'IDD Marketing Images' },
  { value: 'iDDMarketingVideos', label: 'IDD Marketing Videos' },
  { value: 'iDDProductDocuments', label: 'IDD Product Documents' },
  { value: 'iDDProductImages', label: 'IDD Product Images' },
  { value: 'iDDProductImages', label: 'IDD Product Images' },
  { value: 'internalDocuments', label: 'Internal Documents' },
  { value: 'kit&ComponentManagement', label: 'Kit & Component Management' },
  { value: 'LPDProductImages', label: 'LPD Product Images' },
  { value: 'MarketingImages', label: 'Marketing Images' },
  { value: 'p91Certificates', label: 'p91 Certificates' },
  {
    value: 'productImages/Figures/Galleries',
    label: 'Product Images/Figures/Galleries'
  },
  { value: 'productInformation', label: 'Product Information' },
  {
    value: 'scientificandMarketingResources',
    label: 'Scientific and Marketing Resources'
  },
  { value: 'sci&Marketing', label: 'Sci & Marketing' },
  { value: 'SDS', label: 'SDS' },
  { value: 'SDS1', label: 'SDS1' },
  { value: 'software&DataAnalysis', label: 'Software & Data Analysis' },
  { value: 'test', label: 'Test' },
  { value: 'testTemplate', label: 'Test Template' },
  { value: 'vectors', label: 'Vectors' },
  { value: 'videos', label: 'Videos' }
];

// export const ASSET_TYPE_INFO = [
//   { "value": "target chennel", "label": "Target Channel" },
// ];

// export const SITE = [
//   { "value": "site", "label": "Site" },
// ];

// export const PRODUCT_PAGE = [
//   { "value": "hide on product page ", "label": "Hide on Product page" }
// ];

export const LINKS = [
  {
    path: 'home',
    name: 'Home'
  },
  {
    path: 'job-status',
    name: 'Job status'
  },
  {
    path: 'folders',
    name: 'Folders'
  }
];

export const folderItems = [
  {
    name: 'My Folders',
    submenus: [
      {
        name: 'test'
      },
      { name: 'My Orphans' }
    ]
  },
  {
    name: 'Public Folders',
    submenus: [
      {
        name: '3P',
        submenus: [
          {
            name: '3P(CA)'
          }
        ]
      },
      { name: 'ANZ' },
      { name: 'Demo Folder' },
      { name: 'EU' },
      { name: 'FisherSci Print Catalog' }
    ]
  },
  {
    name: 'Recent Folders'
  }
];

export const ASSET_TYPE_SELECT = {
  assetType: [
    {
      value: 'internal repository',
      label: 'Internal Repository',
      data: [
        {
          value: 'FSCA',
          label: 'Fishersci(CA)'
        },
        {
          value: 'FSEU',
          label: 'Fishersci(EU)'
        },
        {
          value: 'FSUS',
          label: 'Fishersci(US)'
        }
      ]
    },
    {
      value: 'none',
      label: 'None',
      data: [
        {
          value: 'none',
          label: 'None'
        }
      ]
    },
    {
      value: 'web',
      label: 'Web',
      data: [
        {
          value: 'CCG_sales360',
          label: 'CCG sales 360'
        },
        {
          value: 'fisher_magellan(CA)',
          label: 'Fisher Magellan(CA)'
        },
        {
          value: 'fisher_magellan(EU)',
          label: 'Fisher Magellan(EU)'
        },
        {
          value: 'fisher_magellan(US)',
          label: 'Fisher Magellan(US)'
        },
        {
          value: 'FSCA',
          label: 'Fishersci(CA)'
        },
        {
          value: 'FSEU',
          label: 'Fishersci(EU)'
        },
        {
          value: 'FSUS',
          label: 'Fishersci(US)'
        },
        {
          value: 'OL',
          label: 'OneLamda'
        },
        {
          value: 'sales360',
          label: 'Sales 360'
        },
        {
          value: 'TF',
          label: 'Thermofisher'
        },
        {
          value: 'TFCN',
          label: 'Thermofisher(CN)'
        },
        {
          value: 'TFIN',
          label: 'Thermofisher(IN)'
        },
        {
          value: 'TFKR',
          label: 'Thermofisher(KR)'
        },
        {
          value: 'TFLR',
          label: 'Thermofisher(LR)'
        }
      ]
    }
  ]
};

export const PRODUCT_PAGE_BOOLEAN_VAL = [
  { value: 'no', label: 'No' },
  { value: 'yes', label: 'Yes' }
];

export const ASSET_TYPE_SUB = {
  scientificResorces: [
    {
      value: 'scientificResorce',
      label: 'Scientific Resorces'
    }
  ],
  referenceMaterials: [
    {
      value: 'applicationNotes',
      label: 'Application Notes'
    },
    {
      value: 'brochures',
      label: 'Brochures'
    },
    {
      value: 'catalogs',
      label: 'Catalogs'
    },
    {
      value: 'fAQ(Database)',
      label: 'FAQ (Database)'
    },
    {
      value: 'flyers',
      label: 'Flyers'
    },
    {
      value: 'handbooks',
      label: 'Handbooks'
    },
    {
      value: 'posters',
      label: 'Posters'
    },
    {
      value: 'referenceMaterial',
      label: 'Reference Materials'
    },
    {
      value: 'scientificResources',
      label: 'Scientific Resources'
    },
    {
      value: 'scientificGuides',
      label: 'Scientific Guides'
    },
    {
      value: 'technicalNotes',
      label: 'Technical Notes'
    },
    {
      value: 'vectorInformation',
      label: 'Vector Information'
    }
  ],
  citations: [
    {
      value: 'articlesPeriodicals',
      label: 'Articles-Periodicals'
    },
    {
      value: 'caseStudies',
      label: 'Case Studies'
    },
    {
      value: 'citations',
      label: 'Citations'
    },
    {
      value: 'LULLS',
      label: 'LULLS'
    },
    {
      value: 'None',
      label: 'none'
    },
    {
      value: 'Slide Presentations',
      label: 'slidePresentations'
    },
    {
      value: 'White Papers',
      label: 'whitePapers'
    }
  ]
};

export const ACCESS_PROCESSING_PROP = {
  access_processing_property: [
    {
      value: 'access_processing_property',
      label: 'Access Processing Property'
    }
  ]
};

export const CUSTOM_SKU_OPTION = {
  skuOption: [
    {
      value: 'new_product',
      label: 'New Product'
    },
    {
      value: 'discontinued_product',
      label: 'Discontinued Product'
    },
    {
      value: 'custom_product',
      label: 'Custom Product'
    }
  ]
};

export const VN_DETAILS = {
  VNDetails: [
    {
      productTitle: 'NuPAGE&trade; MOPS SDS Running Buffer (20X)',
      ERP: 'TF',
      GID: 'GID_900000006782683',
      WebID: 'NP0001',
      VNum: 'LSG_409',
      MPN: 'NP0001',
      fCatNum: ''
    },
    {
      productTitle: 'NuPAGE&trade; MOPS SDS Running Buffer (20X)',
      ERP: 'TF',
      GID: 'GID_900000006782683',
      WebID: 'NP0002',
      VNum: 'LSG_409',
      MPN: 'NP0002',
      fCatNum: ''
    },
    {
      productTitle: 'NuPAGE&trade; MOPS SDS Running Buffer (20X)',
      ERP: 'TF',
      GID: 'GID_900000006782683',
      WebID: 'NP0003',
      VNum: 'LSG_409',
      MPN: 'NP0003',
      fCatNum: ''
    }
  ]
};

export const SINGLE_UPLOAD_SEARCHABLE_FIELD_ID = [
  { id: 'TFS.FIELD.PMID', api: 'AAA' },
  { id: 'TFS.FIELD.WEB_ID', api: '' },
  { id: 'TFS.FIELD.MPN', api: '' },
  { id: 'TFS.FIELD.ROOT_SKU', api: '' }
];

export const NON_EDITABLE_TABLE_FIELDS = [
  'TFS.FIELD.ERP',
  'TFS.FIELD.GID',
  'TFS.FIELD.CAT_ERP',
  'TFS.FIELD.PRODUCT_GLOBAL_IDENTIFIER_GID',
  'TFS.FIELD.PRODUCT_TITLE'
];

export const PRODUCT_IDENITFIER_MAP = {
  'TFS.FIELD.WEB_ID': 'webId',
  'TFS.FIELD.MPN': 'mpn',
  'TFS.FIELD.ROOT_SKU': 'rootSku',
  'TFS.FIELD.PRODUCT_GLOBAL_IDENTIFIER_GID': 'gid',
  'TFS.FIELD.CAT_ERP': 'targetSite',
  'TFS.FIELD.ERP': 'erp',
  'TFS.FIELD.PRODUCT_TITLE': 'productTitle',
  'TFS.FIELD.IS_CUSTOM': 'isCustom'
};


export const TFS_ERP_TARGET_SITE_LU='tfs_erp_target_site_lu';

export const BUCKET_NAME = {
  qa1: 'opentext-tf-ecom-fsg-edam-qa1',
  prod: 'opentext-tf-ecom-fsg-prod-corp',
  qa4: 'opentext-tf-ecom-fsg-edam-qa4',
};
